/**
 * Cached loaders for the Email code past the view itself. Opening Email starts
 * the mailbox and its message list beside the view (homeNavigation.ts), so all
 * three arrive in one round and render without suspending. Compose (TipTap,
 * dictation, signatures) stays out of that round: it loads when a compose
 * window opens, or once the inbox has settled.
 */
import { withCatalogs } from '@/i18n/catalogs';
import { cachedModule } from '@/platform/lib/cachedModule';
import { lazyWithRetry } from '@/platform/lib/lazyWithRetry';

export const loadEmailInterfaceModule = cachedModule(
  withCatalogs(
    [
      'agents',
      'calendar',
      'canvas',
      'clinicalTrials',
      'dashboards',
      'docs',
      'email',
      'lists',
      'meetingCapture',
      'meetingOutputs',
      'platform',
      'settings',
      'teamChat',
      'training',
      'voice',
    ],
    () => import('@/app/email/components/EmailInterface')
  )
);

export const loadEmailListModule = cachedModule(
  withCatalogs(
    ['calendar', 'docs', 'email', 'feasibility', 'settings'],
    () => import('@/app/email/components/EmailInterface/EmailList')
  )
);

export const loadComposeManagerModule = cachedModule(
  withCatalogs(
    [
      'calendar',
      'docs',
      'email',
      'lists',
      'meetingCapture',
      'meetingOutputs',
      'platform',
      'settings',
      'teamChat',
      'voice',
    ],
    () => import('@/app/email/components/EmailInterface/ComposeManager')
  )
);

export const retryEmailInterfaceModule = lazyWithRetry(loadEmailInterfaceModule);
export const retryEmailListModule = lazyWithRetry(loadEmailListModule);
export const retryComposeManagerModule = lazyWithRetry(loadComposeManagerModule);
